export enum ScreeningType {
    NONE = 'NONE', // 일반 전형
    AI_SCREENING = 'AI_SCREENING', // 역량검사 전형
}